import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { formatDate } from "src/Common/common";
import WoMetaRow from "src/Components/Common/wometarow";

import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.5 10V2C7.5 1.72386 7.72386 1.5 8 1.5C8.27614 1.5 8.5 1.72386 8.5 2V10C8.5 10.2761 8.27614 10.5 8 10.5C7.72386 10.5 7.5 10.2761 7.5 10Z"
      fill="#1A2332"
    />
    <path
      d="M1.5 12.6667V10C1.5 9.72386 1.72386 9.5 2 9.5C2.27614 9.5 2.5 9.72386 2.5 10V12.6667C2.5 12.8877 2.58786 13.0996 2.74414 13.2559C2.90042 13.4121 3.11232 13.5 3.33333 13.5H12.6667C12.8877 13.5 13.0996 13.4121 13.2559 13.2559C13.4121 13.0996 13.5 12.8877 13.5 12.6667V10C13.5 9.72386 13.7239 9.5 14 9.5C14.2761 9.5 14.5 9.72386 14.5 10V12.6667C14.5 13.1529 14.3067 13.6191 13.9629 13.9629C13.6191 14.3067 13.1529 14.5 12.6667 14.5H3.33333C2.8471 14.5 2.38093 14.3067 2.03711 13.9629C1.69329 13.6191 1.5 13.1529 1.5 12.6667Z"
      fill="#1A2332"
    />
    <path
      d="M10.9798 6.31315C11.1751 6.11789 11.4916 6.11789 11.6868 6.31315C11.8821 6.50841 11.8821 6.82492 11.6868 7.02018L8.35352 10.3535C8.15825 10.5488 7.84175 10.5488 7.64648 10.3535L4.31315 7.02018C4.11789 6.82492 4.11789 6.50841 4.31315 6.31315C4.50841 6.11789 4.82492 6.11789 5.02018 6.31315L8 9.29297L10.9798 6.31315Z"
      fill="#1A2332"
    />
  </svg>
);

const PrintIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M13.3333 9.83333V6.5C13.3333 6.27899 13.2455 6.06709 13.0892 5.91081C12.9329 5.75453 12.721 5.66667 12.5 5.66667H1.83333C1.61232 5.66667 1.40042 5.75453 1.24414 5.91081C1.08786 6.06709 1 6.27899 1 6.5V9.83333C1 10.0543 1.08786 10.2662 1.24414 10.4225C1.40042 10.5788 1.61232 10.6667 1.83333 10.6667H3.16667C3.44281 10.6667 3.66667 10.8905 3.66667 11.1667C3.66667 11.4428 3.44281 11.6667 3.16667 11.6667H1.83333C1.3471 11.6667 0.880926 11.4734 0.537109 11.1296C0.193293 10.7857 0 10.3196 0 9.83333V6.5C0 6.01377 0.193293 5.54759 0.537109 5.20378C0.880926 4.85996 1.3471 4.66667 1.83333 4.66667H12.5C12.9862 4.66667 13.4524 4.85996 13.7962 5.20378C14.14 5.54759 14.3333 6.01377 14.3333 6.5V9.83333C14.3333 10.3196 14.14 10.7857 13.7962 11.1296C13.4524 11.4734 12.9862 11.6667 12.5 11.6667H11.1667C10.8905 11.6667 10.6667 11.4428 10.6667 11.1667C10.6667 10.8905 10.8905 10.6667 11.1667 10.6667H12.5C12.721 10.6667 12.9329 10.5788 13.0892 10.4225C13.2455 10.2662 13.3333 10.0543 13.3333 9.83333Z"
      fill="#1A2332"
    />
    <path
      d="M10.6667 5.16667V1.16667C10.6667 1.12246 10.6491 1.08008 10.6178 1.04883C10.5866 1.01757 10.5442 1 10.5 1H3.83333C3.78913 1 3.74675 1.01757 3.71549 1.04883C3.68424 1.08008 3.66667 1.12246 3.66667 1.16667V5.16667C3.66667 5.44281 3.44281 5.66667 3.16667 5.66667C2.89052 5.66667 2.66667 5.44281 2.66667 5.16667V1.16667C2.66667 0.857247 2.78967 0.560589 3.00846 0.341797C3.22726 0.123004 3.52391 0 3.83333 0H10.5C10.8094 0 11.1061 0.123004 11.3249 0.341797C11.5437 0.56059 11.6667 0.857248 11.6667 1.16667V5.16667C11.6667 5.44281 11.4428 5.66667 11.1667 5.66667C10.8905 5.66667 10.6667 5.44281 10.6667 5.16667Z"
      fill="#1A2332"
    />
    <path
      d="M10.6667 9.16667C10.6667 9.07462 10.592 9 10.5 9H3.83333C3.74129 9 3.66667 9.07462 3.66667 9.16667V13.1667C3.66667 13.2587 3.74129 13.3333 3.83333 13.3333H10.5C10.592 13.3333 10.6667 13.2587 10.6667 13.1667V9.16667ZM11.6667 13.1667C11.6667 13.811 11.1443 14.3333 10.5 14.3333H3.83333C3.189 14.3333 2.66667 13.811 2.66667 13.1667V9.16667C2.66667 8.52233 3.189 8 3.83333 8H10.5C11.1443 8 11.6667 8.52233 11.6667 9.16667V13.1667Z"
      fill="#1A2332"
    />
  </svg>
);

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path
      d="M8.125 0C6.51803 0 4.94714 0.476523 3.611 1.36931C2.27485 2.2621 1.23344 3.53105 0.618482 5.0157C0.00352044 6.50035 -0.157382 8.13401 0.156123 9.71011C0.469628 11.2862 1.24346 12.7339 2.37976 13.8702C3.51606 15.0065 4.9638 15.7804 6.5399 16.0939C8.11599 16.4074 9.74966 16.2465 11.2343 15.6315C12.719 15.0166 13.9879 13.9752 14.8807 12.639C15.7735 11.3029 16.25 9.73197 16.25 8.125C16.2477 5.97081 15.391 3.90551 13.8677 2.38227C12.3445 0.85903 10.2792 0.00227486 8.125 0ZM7.8125 3.75C7.99792 3.75 8.17918 3.80498 8.33335 3.908C8.48752 4.01101 8.60768 4.15743 8.67864 4.32873C8.7496 4.50004 8.76816 4.68854 8.73199 4.8704C8.69582 5.05225 8.60653 5.2193 8.47542 5.35041C8.3443 5.48152 8.17726 5.57081 7.9954 5.60699C7.81354 5.64316 7.62504 5.62459 7.45374 5.55364C7.28243 5.48268 7.13601 5.36252 7.033 5.20835C6.92999 5.05418 6.875 4.87292 6.875 4.6875C6.875 4.43886 6.97378 4.2004 7.14959 4.02459C7.32541 3.84877 7.56386 3.75 7.8125 3.75ZM8.75 12.5C8.41848 12.5 8.10054 12.3683 7.86612 12.1339C7.6317 11.8995 7.5 11.5815 7.5 11.25V8.125C7.33424 8.125 7.17527 8.05915 7.05806 7.94194C6.94085 7.82473 6.875 7.66576 6.875 7.5C6.875 7.33424 6.94085 7.17527 7.05806 7.05806C7.17527 6.94085 7.33424 6.875 7.5 6.875C7.83152 6.875 8.14947 7.0067 8.38389 7.24112C8.61831 7.47554 8.75 7.79348 8.75 8.125V11.25C8.91576 11.25 9.07474 11.3158 9.19195 11.4331C9.30916 11.5503 9.375 11.7092 9.375 11.875C9.375 12.0408 9.30916 12.1997 9.19195 12.3169C9.07474 12.4342 8.91576 12.5 8.75 12.5Z"
      fill="#0065FD"
    />
  </svg>
);

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M4 4L12 12M12 4L4 12" stroke="#868DA6" strokeWidth="1.33" strokeLinecap="round" />
  </svg>
);

function HeaderButton({ icon, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="h-[32px] px-3 bg-white rounded-lg border border-[#C9CEE2] shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] flex items-center justify-center gap-2 cursor-pointer text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize"
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}

const PreviewSTModal = ({ shown, title = "Service Ticket Preview", cancelClicked, pdfUrl, wo }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const { getFilePluginInstance, printPluginInstance } = defaultLayoutPluginInstance.toolbarPluginInstance;
  const { Download: DownloadTrigger } = getFilePluginInstance;
  const { Print: PrintTrigger } = printPluginInstance;

  const startDate = wo?.startDate ? formatDate(wo.startDate, "MMM D, YYYY") : "";

  return (
    shown && (
      <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-20 flex items-center justify-center z-50">
        <OutsideClickHandler onOutsideClick={cancelClicked}>
          <div className="bg-white rounded-[12px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] flex flex-col items-start w-[80vw] max-w-[1280px] h-[95vh] max-h-[966px] relative overflow-hidden">
            {/* Header */}
            <div className="self-stretch pt-6 pb-4 px-8 border-b border-[#E5E8F3] flex flex-col justify-start items-start gap-4">
              <div className="self-stretch flex items-center justify-between">
                <span className="text-[#1A2332] font-OpenSansSemiBold text-[20px] leading-7 capitalize">{title}</span>
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-3">
                    <DownloadTrigger>
                      {(props) => <HeaderButton icon={<DownloadIcon />} label="Download PDF" onClick={props.onClick} />}
                    </DownloadTrigger>
                    <PrintTrigger>
                      {(props) => <HeaderButton icon={<PrintIcon />} label="Print" onClick={props.onClick} />}
                    </PrintTrigger>
                  </div>
                  <div className="pl-4 flex items-center gap-2">
                    <button
                      type="button"
                      onClick={cancelClicked}
                      aria-label="Close"
                      className="w-[32px] h-[32px] rounded-full flex items-center justify-center cursor-pointer"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                </div>
              </div>

              <WoMetaRow wo={wo} date={startDate} />
            </div>

            {/* Body */}
            <div className="w-full flex-1 min-h-0 px-8 py-6 flex flex-col gap-4">
              <div className="self-stretch p-3 bg-[#F5F9FF] rounded-lg border border-[#C8E1FF] backdrop-blur-[48px] flex items-start gap-2">
                <span className="w-5 h-5 shrink-0 flex items-center justify-center">
                  <InfoIcon />
                </span>
                <div className="flex-1 flex flex-col items-start">
                  <span className="self-stretch text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize break-words">
                    View Only
                  </span>
                  <span className="self-stretch text-[#5F6477] font-OpenSansRegular text-[12px] leading-[18px] tracking-[0.12px] break-words">
                    This service ticket can be viewed but cannot be edited until the work order is marked Complete.
                  </span>
                </div>
              </div>

              <div className="flex-1 min-h-0">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                  <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                </Worker>
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    )
  );
};

export default PreviewSTModal;
